<!--
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-01 12:57:25
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-03 20:31:17
 * @FilePath: \Collection\src\views\ModuleAndLang\components\SetHeader copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-01 09:34:24
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-01 11:34:53
 * @FilePath: \Collection\src\views\ModuleAndLang\components\SetHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="checkLangs">
    <div
      v-for="lang in dataSource"
      :key="lang.value"
      :value="lang.value"
      :class="`checkLang ${checkLang === lang.value ? 'check' : ''}`"
      @click="() => checkLangChange(lang.value)"
    >
      {{ lang.label }}
    </div>
  </div>
</template>
<script>
// import { useRoute } from 'vue-router'
// import { toRefs, reactive, onMounted } from 'vue'
// import { common_lang_get } from 'server/modules/3426'
export default {
  props: {
    checkLang: String,
    dataSource: Array,
    checkLangChange: Function
  },
  setup() {
    // const routeQuery = useRoute().query
    // const { channelId, siteId, brandId, terminalId } = routeQuery
    // const state = reactive({
    //   langList: [],
    //   defaultLang: ''
    // })
    // const getSiteLang = async () => {
    //   const { data } = await common_lang_get({
    //     channelId,
    //     siteId,
    //     brandId,
    //     terminalId
    //   })

    //   state.langList = Object.entries(data.languageMap).map(([key, value]) => ({
    //     label: key,
    //     value: value
    //   }))

    //   props.checkLangChange(data.defaultLanguageCode)
    // }

    // onMounted(async () => {
    //   await getSiteLang()
    //   const res = await col_lang_query({
    //     colId,
    //     peopleType: initState.newOldKey
    //   })
    //   res.data.colBannerLang.langs.forEach(lang => {
    //     for (let i = 0; i < lang.banners.length; i++) {
    //       if (
    //         JSON.parse(lang.banners[i].bannerExt) &&
    //         JSON.parse(lang.banners[i].bannerExt).args
    //       ) {
    //         let value = JSON.parse(lang.banners[i].bannerExt).args
    //         lang.banners[i].bannerExt = testArgs(value)
    //       }
    //     }
    //     lang.fileList1 = [lang.banners[0].imgUrl]
    //     lang.fileList2 = [lang.banners[1].imgUrl]
    //     lang.fileList3 = [lang.banners[2].imgUrl]
    //   })
    //   originData.value = res.data
    //   state.lang = state.langList[0].value
    // })

    return {
      // ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.checkLangs {
  /* background: #f0f0f0; */
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 15px;
}

.checkLang {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ddd;
}

.checkLang.check {
  background: #ffffff;
  border-color: #1890ff;
}
</style>
